export default __webpack_public_path__ + "static/media/top-header-1.e6febc8a.png";